const statementType = {
	AND_OR: 'and-or',
	OR_AND: 'or-and'
}

export default statementType

statementType.__filename__ = 'components/logic/model/statement-type.js'
